
    import * as React from 'react';

    const ShippingAlt24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" style={svgStyle}><path d="M20 8.89l-3.236-.904-8.038 2.5 2.931.927L20 8.89zm1.785-.54l.08-.024v7.525L11.65 19.533l-9.788-3.687V8.358l-.001-.005h.001v-.035l.058.018 9.731-2.818 5.098 1.425.04-.012.008.026 4.988 1.394zm-18.146.53l3.418 1.08 7.934-2.47-3.335-.932L3.64 8.88zm7.515 3.423l-8.292-2.62v5.471l8.292 3.123v-5.974zm1 .005v5.98l8.711-3.14V9.675l-8.711 2.634z" /></svg>
        </div>
      );
    };

    ShippingAlt24.displayName = 'ShippingAlt24';

    export default ShippingAlt24;
  